export default "__VITE_ASSET__DDe6$IPh__"